"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appWithAuthNext = void 0;
const hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
const react_1 = __importDefault(require("react"));
const auth_context_1 = require("./auth.context");
const AuthNextApiClient_1 = __importDefault(require("./AuthNextApiClient"));
const getAuthPageProp_1 = require("./getAuthPageProp");
const useCrossTabLogoutHandler_1 = require("./useCrossTabLogoutHandler");
function appWithAuthNext(options = {}) {
    const { endpointBasePath = `/api/auth`, logoutCallback } = options;
    const client = new AuthNextApiClient_1.default(endpointBasePath);
    return function wrapAppWithAuthNext(AppComponent) {
        function AppWithAuthNext(props) {
            const user = (0, getAuthPageProp_1.usePagePropsAuth)(props.pageProps);
            (0, useCrossTabLogoutHandler_1.useCrossTabLogoutHandler)({ logoutCallback });
            return (react_1.default.createElement(auth_context_1.AuthProvider, { user: user, client: client },
                react_1.default.createElement(AppComponent, Object.assign({}, props))));
        }
        return (0, hoist_non_react_statics_1.default)(AppWithAuthNext, AppComponent);
    };
}
exports.appWithAuthNext = appWithAuthNext;
//# sourceMappingURL=appWithAuthNext.js.map